
  <nav  class="navbar navbar-expand-sm border-bottom box-shadow mb-3 navbar-fixed-top navbar-toggleable-sm" >
    <div class="container" >
      
      &nbsp;&nbsp;&nbsp;&nbsp;

      <a class="navbar-brand" *ngIf="!userData.isLoggedIn" [routerLink]="['/addusers']" style="color:white;">New User ? Sign Up</a>
      <button class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target=".navbar-collapse"
              aria-label="Toggle navigation"
              [attr.aria-expanded]="isExpanded"
              (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
           [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="!userData.isLoggedIn" [routerLink]='["/login"]'>Sign In</a>
          </li>
          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn && userData.role==userRole.User" [routerLink]='["/users"]'>User Home</a>
          </li>

          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn && userData.role==userRole.Admin" [routerLink]='["/adminhome"]'>Admin Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn && userData.role==userRole.Teacher" [routerLink]='["/teacher"]'>Teacher Home</a>
          </li>

          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn && userData.role==userRole.Admin" [routerLink]='["/adminhome/quizes"]'>Quiz Section</a>
          </li>

          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn && userData.role==userRole.Manager" [routerLink]='["/manager"]'>Manager Home</a>
          </li>

          <li class="nav-item" [routerLinkActive]='["link-active"]'>
            <a class="nav-link text-light" *ngIf="userData.isLoggedIn" (click)=logout() [routerLink]=''>Logout</a>
          </li>


          <li class="nav-item" [routerLinkActive]='["link-active"]' *ngIf="userData.isLoggedIn">
            <a class="nav-link text-light">Welcome <b>{{userData.fullName}}</b> </a>
          </li>

          <!--Orginal here  -->

          <li class="nav-item"
              [routerLinkActive]="['link-active']"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="navbar-item"><img src="assets/img/logo.png" width="200" height="60"></a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

